var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowFilled = function SvgArrowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9231 9.83527L12.6261 7.05264C12.4832 6.93202 12.2624 7.03201 12.2624 7.21737L12.2624 12.7826C12.2624 12.968 12.4832 13.068 12.6261 12.9473L15.9231 10.1647C16.0256 10.0781 16.0256 9.92185 15.9231 9.83527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.13217C4 9.01235 4.09865 8.91522 4.22033 8.91522L13.3641 8.91522V11.0848L4.22033 11.0848C4.09865 11.0848 4 10.9876 4 10.8678V9.99999V9.13217Z",
    fill: "currentColor"
  })));
};
export default SvgArrowFilled;